import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { decamelizeFilters } from "PFApp/analytics/parts/top_actions_panel/export_wizard_content/export_fields_utils";
import { ExportFilterGroups } from "PFApp/analytics/types/export_analytics";
import { Filter, PeriodFilter, Value } from "PFTypes";
import { useEffect } from "react";

import { findPeriodFilter, mapValuesInFilterGroup } from "./helpers";
import { STANDARD_FILTERS_NAME } from "./use_filter_groups";

type UseDefaultPeriod = {
  entries: ExportFilterGroups | undefined;
};

export const useDefaultPeriod = ({ entries }: UseDefaultPeriod) => {
  const {
    updateData,
    state: {
      data: { selectedFilters }
    }
  } = useAnalyticsModalContext();

  useEffect(() => {
    if (!entries) {
      return;
    }
    const currentPeriodValue = findPeriodFilter<Value>(selectedFilters);
    if (currentPeriodValue) {
      return;
    }
    const periodFilter = findPeriodFilter<Filter>(entries) || {};
    const defaultPeriodValue = (periodFilter as PeriodFilter).period;
    if (periodFilter && defaultPeriodValue) {
      const updatedStandardFilters = mapValuesInFilterGroup<Filter, Value>(
        entries[STANDARD_FILTERS_NAME],
        () => (filter, filterKey) => filterKey === "period" ? { period: defaultPeriodValue } : filter.value
      );
      updateData({
        selectedFilters: decamelizeFilters({
          ...selectedFilters,
          [STANDARD_FILTERS_NAME]: updatedStandardFilters
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entries]);
};
